import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { braTyc, chlTyc, colTyc, creditTyc, gtmTyc, phlTyc, tyc } from './tyc';
import { AuthService } from 'src/app/pages/auth/abstraction/auth.service';
import { EXCHANGE_COUNTRY } from 'src/app/pages/auth/models/Onboarding';
import {
  privacy,
  privacy_bra,
  privacy_chl,
  privacy_col,
  privacy_gtm,
  privacy_phl,
} from './privacy';
import { WIDGET_COMPANY } from 'src/app/pages/auth/models/Whitelabel';

@Component({
  selector: 'app-tyc',
  templateUrl: './tyc.component.html',
  styleUrls: ['./tyc.component.scss'],
})
export class TycComponent implements OnInit {
  tyc = tyc;
  exchangeCountry: EXCHANGE_COUNTRY;
  EXCHANGE_COUNTRY = EXCHANGE_COUNTRY;
  constructor(
    public dialogRef: MatDialogRef<TycComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private authSvc: AuthService,
  ) {
    this.authSvc.loggedUserObs.subscribe((user) => {
      if (user?.exchangeCountry === EXCHANGE_COUNTRY.CHL) {
        this.tyc = chlTyc;
      } else if (user?.exchangeCountry === EXCHANGE_COUNTRY.COL) {
        this.tyc = colTyc;
      } else if (user?.exchangeCountry === EXCHANGE_COUNTRY.BRA) {
        this.tyc = braTyc;
      } else if (user?.exchangeCountry === EXCHANGE_COUNTRY.GTM) {
        this.tyc = gtmTyc;
      } else if (user?.exchangeCountry === EXCHANGE_COUNTRY.PHL) {
        this.tyc = phlTyc;
      }
      this.exchangeCountry = user?.exchangeCountry as EXCHANGE_COUNTRY;
    });
    this.authSvc.widgetUserObs.subscribe((user) => {
      if (user && user.user?.companyId === WIDGET_COMPANY.CREDIT) {
        this.tyc = creditTyc;
      }
    });
  }

  ngOnInit(): void {}

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  closeDialog() {
    this.dialogRef.close(true);
  }

  privacyByCountry(exchangeCountry: EXCHANGE_COUNTRY) {
    switch (exchangeCountry) {
      case EXCHANGE_COUNTRY.CHL:
        return privacy_chl;
      case EXCHANGE_COUNTRY.COL:
        return privacy_col;
      case EXCHANGE_COUNTRY.BRA:
        return privacy_bra;
      case EXCHANGE_COUNTRY.GTM:
        return privacy_gtm;
      case EXCHANGE_COUNTRY.PHL:
        return privacy_phl;
      default:
        return privacy;
    }
  }
}
